import { requestURLs } from "@/Environment";
import { useMutation } from "@tanstack/react-query";
import ApiRequest from "../ApiRequest";
import { TaskNote } from "./useAddTaskNotesMutation";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
type RemoveNoteResponseType = ResponseType<TaskNote>;

function useRemoveNoteMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<RemoveNoteResponseType>["response"],
    AxiosResponseAndError<RemoveNoteResponseType>["error"],
    string
  >({
    mutationFn: async (data) => {
      return ApiRequest.delete<RemoveNoteResponseType>(
        `${requestURLs.taskNote}${data}`
      );
    },
  });

  return mutation;
}

export default useRemoveNoteMutation;